import { useEffect } from "react";
import Spinner from "./Spinner/spinner";

export const KYCRedirectScreen = ({ message, setCurrentStep }) => {
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep(prev => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [setCurrentStep]);

  return (
    <div className="flex flex-col font-atkinson items-center h-[100dvh] justify-center bg-white text-center px-4">
      <Spinner />

      <h2 className="mt-4 text-lg font-bold text-gray-900">Hang tight!</h2>
      <p className="mt-1 text-[15px] text-gray-600">
        {message.split("\n").map((msg, index) => (
          <span key={index}>
            {msg}
            <br />
          </span>
        ))}
      </p>

      <div className="absolute bottom-6 flex flex-col items-center">
        <div className="text-center text-xs text-gray-500">
          <img
            src="/assets/img/Footer logo.png"
            alt="Digitmoney logo"
            className="mx-auto h-4 mb-1"
          />
          Lending Partner{" "}
          <img
            src="/assets/img/dmiicon.png"
            alt="DMI Finance logo"
            className="inline h-4 ml-1"
          />
        </div>
      </div>
    </div>
  );
};
